"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var POINT_TYPE;
(function (POINT_TYPE) {
    POINT_TYPE["empid"] = "emp-id";
    POINT_TYPE["empth"] = "emp-th";
})(POINT_TYPE || (POINT_TYPE = {}));
exports.default = POINT_TYPE;
